(function() {
  if (window.__canvaiEntriesInitialized) return;
  window.__canvaiEntriesInitialized = true;

  console.log('[Canvai] Initializing entries script...');

  //
  // ---------- Utils ----------
  //
  function centsToDollars(cents) {
    const intCents = parseInt(cents, 10);
    if (isNaN(intCents)) return 0;
    const str = intCents.toString();
    if (str.length > 2) {
      const mainPart = str.slice(0, -2);
      const decimalPart = str.slice(-2);
      return parseFloat(mainPart + "." + decimalPart);
    } else {
      return intCents / 100;
    }
  }

  function sanitizeId(str) {
    if (typeof str !== "string") str = String(str);
    return str.replace(/\D/g, "");
  }

  async function fetchSweepDataForProducts(platformId, productIds) {
    const query = `
      query QuerySweepstakeDetailsByProductId($platform: String!, $platformId: String!, $productIds: [String!]) {
        sweepstakeDetailsByProductId(platform: $platform, platformId: $platformId, productIds: $productIds) {
          id
          entryManagement
          productsAllowedByDefault
          bonusEntriesDefault
          products(productIds: $productIds) {
            productId
            productAllowed
            productBonusEntries
          }
        }
      }
    `;
    const variables = { platform: "Shopify", platformId, productIds };

    console.log('[Canvai] Fetching sweep data:', { platformId, productIds });

    const resp = await fetch("https://backend.cleansweeps.app/graphql", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables })
    });

    if (!resp.ok) {
      console.error('[Canvai] CleanSweep API error:', resp.status);
      throw new Error("CleanSweep API error");
    }
    
    const json = await resp.json();
    console.log('[Canvai] Sweep data received:', json);

    return (json.data && json.data.sweepstakeDetailsByProductId)
      ? json.data.sweepstakeDetailsByProductId
      : [];
  }

  //
  // ---------- Odomètre / rouleau animé ----------
  //
  function buildSpinningDigitColumn(repeatCount) {
    const col = document.createElement("span");
    col.className = "digit-column";
    col.style.display = "inline-block";
    col.style.position = "relative";
    col.style.height = "1em";
    col.style.overflow = "hidden";
    col.style.lineHeight = "1em";
    col.style.fontVariantNumeric = "tabular-nums";
    col.style.minWidth = "0.6em";

    const track = document.createElement("span");
    track.className = "digit-track";
    track.style.display = "inline-flex";
    track.style.flexDirection = "column";
    track.style.willChange = "transform";
    track.style.transform = "translateY(0)";
    track.style.transition = "none";

    for (let r = 0; r < repeatCount; r++) {
      for (let n = 0; n <= 9; n++) {
        const d = document.createElement("span");
        d.textContent = n.toString();
        d.style.display = "block";
        d.style.height = "1em";
        d.style.lineHeight = "1em";
        d.style.color = "#ffffff";
        d.style.textAlign = "center";
        d.style.fontFamily = "Montserrat, Arial, sans-serif";
        d.style.fontWeight = "800";
        d.style.fontSize = "14px";
        track.appendChild(d);
      }
    }

    col.appendChild(track);
    return col;
  }

  function buildStaticColumn(symbol) {
    const col = document.createElement("span");
    col.className = "digit-column digit-column-static";
    col.style.display = "inline-block";
    col.style.position = "relative";
    col.style.height = "1em";
    col.style.overflow = "hidden";
    col.style.lineHeight = "1em";
    col.style.minWidth = "0.6em";

    const track = document.createElement("span");
    track.className = "digit-track";
    track.style.display = "inline-flex";
    track.style.flexDirection = "column";
    track.style.willChange = "transform";
    track.style.transition = "none";
    track.style.transform = "translateY(0)";

    const d = document.createElement("span");
    d.textContent = symbol;
    d.style.display = "block";
    d.style.height = "1em";
    d.style.lineHeight = "1em";
    d.style.color = "#ffffff";
    d.style.textAlign = "center";
    d.style.fontFamily = "Montserrat, Arial, sans-serif";
    d.style.fontWeight = "800";
    d.style.fontSize = "14px";

    track.appendChild(d);
    col.appendChild(track);
    return col;
  }

  function animateOdometer(containerEl, finalNumber) {
    const formatted = finalNumber.toLocaleString("en-US");
    const chars = formatted.split("");

    containerEl.innerHTML = "";
    containerEl.style.display = "inline-flex";
    containerEl.style.alignItems = "flex-start";
    containerEl.style.height = "1em";
    containerEl.style.overflow = "hidden";

    const totalDigits = chars.length;
    const columns = [];

    for (let i = 0; i < totalDigits; i++) {
      const ch = chars[i];
      const indexFromRight = (totalDigits - 1) - i;

      if (/[0-9]/.test(ch)) {
        const finalDigit = parseInt(ch, 10);
        const tours = 2 + indexFromRight;

        const col = buildSpinningDigitColumn(tours);
        containerEl.appendChild(col);

        columns.push({
          isDigit: true,
          finalDigit,
          tours,
          col,
          index: i
        });
      } else {
        const col = buildStaticColumn(ch);
        containerEl.appendChild(col);

        columns.push({
          isDigit: false,
          col,
          index: i
        });
      }
    }

    columns.forEach(obj => {
      if (!obj.isDigit) return;
      const track = obj.col.querySelector(".digit-track");
      track.style.transition = "none";
      track.style.transform = "translateY(0)";
    });

    requestAnimationFrame(() => {
      columns.forEach(obj => {
        if (!obj.isDigit) return;
        const track = obj.col.querySelector(".digit-track");

        const stepsTotal = (obj.tours - 1) * 10 + obj.finalDigit;
        const delayMs = obj.index * 80;
        const durationMs = 500 + (obj.tours * 140);

        track.style.transition =
          `transform ${durationMs}ms cubic-bezier(0.16, 1, 0.3, 1) ${delayMs}ms`;
        track.style.transform =
          `translateY(calc(-1em * ${stepsTotal}))`;
      });
    });
  }

  //
  // ---------- Calcul des entries ----------
  //
  function computeEntriesForDisplay({
    priceDollars,
    productInfo,
    entryManagement
  }) {
    const entryPer = parseFloat(entryManagement.entryPer);
    const dollarSpent = parseFloat(entryManagement.dollarSpent);

    const safeDollarSpent = !isNaN(dollarSpent) && dollarSpent > 0 ? dollarSpent : 1;
    const entriesPerDollar = !isNaN(entryPer) ? (entryPer / safeDollarSpent) : 0;

    const roundUp = (entryManagement.roundUp !== undefined)
      ? entryManagement.roundUp
      : true;

    const roundingFunction = roundUp ? Math.ceil : Math.floor;
    const roundedPrice = roundingFunction(priceDollars);
    const baseEntries = roundingFunction(entriesPerDollar * roundedPrice);

    let bonusUsed = 0;
    let productAllowed = true;

    if (productInfo) {
      if (productInfo.productAllowed === false) {
        productAllowed = false;
      }
      if (productInfo.productBonusEntries != null) {
        bonusUsed = productInfo.productBonusEntries;
      }
    }

    const finalEntries = baseEntries + bonusUsed;

    return {
      finalEntries,
      entriesPer: entryPer
    };
  }

  //
  // ---------- Rendu d'un bloc produit ----------
  //
  function renderEntriesForBlock(block, sweepData) {
    const productGID = block.dataset.productId;
    const productIdSanitized = sanitizeId(productGID);
    const priceCents = block.dataset.priceCents;
    const priceDollars = centsToDollars(priceCents);

    const digitsContainer = block.querySelector(".entries-digits");
    const labelEl = block.querySelector(".entries-label");
    const multiplierEl = block.querySelector(".multiplier-box");

    if (!digitsContainer || !labelEl) {
      console.warn('[Canvai] Missing required elements in block');
      return;
    }

    // ---- Lire les tags du produit pour entries_X ----
    let tagMultiplier = null;
    const tagsStr = block.dataset.productTags || "";
    
    console.log('[Canvai] Product tags:', tagsStr);
    
    if (tagsStr) {
      const parts = tagsStr.split(",");
      for (const raw of parts) {
        const t = raw.trim();
        const match = /^entries_(\d+)$/i.exec(t);
        if (match) {
          const val = parseFloat(match[1]);
          if (!isNaN(val) && val > 0) {
            tagMultiplier = val;
            console.log('[Canvai] Found tag multiplier:', tagMultiplier);
            break;
          }
        }
      }
    }

    // Trouver la sweepstake qui correspond à ce produit
    let sweepDetail = null;
    let productInfo = null;

    for (const detail of sweepData) {
      const found = detail.products.find(
        p => sanitizeId(p.productId) === productIdSanitized
      );
      if (found) {
        sweepDetail = detail;
        productInfo = found;
        break;
      }
    }

    if (!sweepDetail && sweepData.length > 0) {
      sweepDetail = sweepData[0];
      productInfo = null;
    }

    if (!sweepDetail) {
      console.warn('[Canvai] No sweep detail found');
      digitsContainer.innerHTML = "";
      labelEl.textContent = "";
      if (multiplierEl) multiplierEl.style.display = "none";
      block.setAttribute("data-clean-sweeps-loaded", "true");
      return;
    }

    let entryManagement;
    try {
      entryManagement = JSON.parse(sweepDetail.entryManagement);
    } catch(e) {
      console.error('[Canvai] Failed to parse entryManagement:', e);
      entryManagement = null;
    }

    if (!entryManagement) {
      console.warn('[Canvai] No entryManagement found');
      digitsContainer.innerHTML = "";
      labelEl.textContent = "";
      if (multiplierEl) multiplierEl.style.display = "none";
      block.setAttribute("data-clean-sweeps-loaded", "true");
      return;
    }

    const {
      finalEntries,
      entriesPer
    } = computeEntriesForDisplay({
      priceDollars,
      productInfo,
      entryManagement
    });

    console.log('[Canvai] Calculated entries:', {
      finalEntries,
      entriesPer,
      tagMultiplier,
      priceDollars
    });

    labelEl.textContent = "Entries";

    // Badge multiplicateur: priorité au tag, sinon CleanSweep
    if (multiplierEl) {
      const displayMultiplier = tagMultiplier !== null ? tagMultiplier : entriesPer;
      
      console.log('[Canvai] Display multiplier:', displayMultiplier);

      if (displayMultiplier > 1) {
        multiplierEl.style.display = "flex";
        multiplierEl.textContent = displayMultiplier + "X";
        multiplierEl.style.animation = "flashMult 1.2s ease-in-out infinite alternate";
      } else {
        multiplierEl.style.display = "none";
        multiplierEl.textContent = "";
        multiplierEl.style.animation = "none";
      }
    }

    // Lancer l'odomètre seulement quand visible
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateOdometer(digitsContainer, finalEntries);
          obs.disconnect();
        }
      });
    }, { threshold: 0.3 });

    io.observe(block);
    block.setAttribute("data-clean-sweeps-loaded", "true");
  }

  //
  // ---------- Init + support infinite scroll / "load more" ----------
  //
  async function processNewBlocks() {
    const newBlocks = Array.from(
      document.querySelectorAll(".canvai-entries-wrapper")
    ).filter(b => !b.hasAttribute("data-clean-sweeps-loaded"));

    if (!newBlocks.length) return;

    console.log('[Canvai] Processing', newBlocks.length, 'new blocks');

    const platformId = newBlocks[0].dataset.platformId;
    const productIds = [...new Set(newBlocks.map(b => b.dataset.productId))];

    let sweepData = [];
    try {
      sweepData = await fetchSweepDataForProducts(platformId, productIds);
    } catch (err) {
      console.error('[Canvai] Error fetching sweep data:', err);
      return;
    }

    newBlocks.forEach(block => renderEntriesForBlock(block, sweepData));
  }

  document.addEventListener("DOMContentLoaded", processNewBlocks);

  const domObserver = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === "childList" && m.addedNodes.length) {
        processNewBlocks();
        break;
      }
    }
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

  // Style: flash du multiplicateur
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes flashMult {
      0%   { background-color:#000; color:#fff; }
      100% { background-color:#e20808; color:#fff; }
    }

    .canvai-pill{
      position:relative;
      display:flex;
      align-items:center;
      gap:0;
      border-radius:9999px;
      overflow:hidden;
      background: linear-gradient(90deg,#161616 0%, #252525 40%, #b8ff00 100%);
      box-shadow:0 6px 18px rgba(0,0,0,.35), inset 0 0 0 1px rgba(255,255,255,.06);
      isolation:isolate;
    }

    .canvai-pill::before{
      content:"";
      position:absolute;
      top:-40%;
      left:-60%;
      width:40%;
      height:180%;
      background: linear-gradient(120deg,
        rgba(255,255,255,0) 0%,
        rgba(255,255,255,0.6) 50%,
        rgba(255,255,255,0) 100%
      );
      opacity:0.65;
      transform: skewX(-25deg);
      pointer-events:none;
      animation: canvaiGlare 3s linear infinite;
      mix-blend-mode: screen;
    }

    @keyframes canvaiGlare {
      0%   { left:-60%; }
      100% { left:130%; }
    }
  `;
  document.head.appendChild(style);
})();